import { FileDataService } from "../file-data.service";
import { Input, Component, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef} from "@angular/core";
import { Folder, Dataset,Account } from "4d-mapper";
import { Observable, Subscription, of } from "rxjs";
import { map, filter } from "rxjs/operators";
import { Store, BaseEvent, ArrayStore } from 'vasat/dist/src/veflux'
import { VasatModel, VasatSearchQuery } from "vasat";
import { TreeNode, TreeEvent } from "./tree-events";
import { StreamDataService } from "../stream-data.service";

@Component({
    selector:'tree-view',
    template:`
    <ul class="fdm-tree-structure">
        <folder-node *ngFor="let cur of rootLevels | async" [folder]="cur" [_selectedFolder]="_selectedFolder" (change)="changed($event)"></folder-node>
    </ul>
    `
    ,changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreeComponent{

    rootLevels:Observable<TreeNode[]> = null
    
    _rootLevelStore:ArrayStore<TreeNode,string,TreeEvent>    
    _selectedFolder:Store<TreeNode,any,TreeEvent>
    
    private _subs:Subscription[] = []
    
    
    @Input()
    set selectedFolder(s:Store<TreeNode,any,TreeEvent>){
        this._selectedFolder = s;
    }
    @Input()
    set rootLevelStore(s:ArrayStore<TreeNode,string,TreeEvent>    ){
        this._rootLevelStore = s
    }
    @Input()
    disableSelection:boolean

    @Output()
    change = new EventEmitter<TreeEvent>()

    constructor( private cdr:ChangeDetectorRef){
        
    }

    ngOnInit(){
        this.rootLevels = this._rootLevelStore.state
    }

    ngOnDestroy(){
        this._subs.forEach(s => s.unsubscribe())
    }
    
    changed(ev:TreeEvent){
        this.change.emit(ev)
        // console.log('#changed TREE', ev.event, ev );
        if(!this.disableSelection && ev.event == 'selected' && this._selectedFolder) {
            this._selectedFolder.value = ev.item;
            this.cdr.detectChanges()
        }
            
    }
}

@Component({
    selector:'folder-node',
    templateUrl: './tree.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreeNodeComponent{
    @Input()
    folder:TreeNode

    @Input()
    _selectedFolder:Store<TreeNode,any,TreeEvent>

    @Output()
    change = new EventEmitter<TreeEvent>()
    
    hasChildren:boolean
    expanded:boolean
    isSelected:boolean = false;
    isImported:boolean = false;
    isLeaf:boolean 
    children:TreeNode[] = null
    
    isFile:boolean

    id:any = null;

    private subs:Subscription[] = []
    
    constructor(private cdr:ChangeDetectorRef){
    }
    ngOnInit(){
        this.folder.load()
        this.folder.redraw = () => this.cdr.detectChanges()

        
        this.isLeaf = this.folder.isLeaf
        this.isFile = this.folder.selectable || this.folder.ref instanceof Dataset;

        if ( this.folder.ref.id ) {
            this.id = ( this.isFile ? 'file-':'folder-' ) + this.folder.ref.id;
        } else {
            if ( this.folder.ref.layer && this.folder.ref.layer.id ) {
                this.id = ( this.isFile ? 'file-':'folder-' ) + this.folder.ref.layer.id;
            } else {
                this.id = ( this.isFile ? 'file-':'folder-' ) + this.uuid();
            }
        }

        if ( this.folder['_imported'] ) {
            this.isImported = true;
        }

        console.log('#init_node', this.id, this.folder );

        if(!this.isLeaf){
            if(this.folder.expanded){
                // console.log('#toggle AUTO', this.id );
                this.toggle()
            }
            
            this.updateHasChildren()
        }
        
        if (this._selectedFolder){
            this.subs.push(this._selectedFolder.events.subscribe(s => {
                if(!this.expanded && s.event == 'ADD' && s.item.ref != this.folder.ref && s.args && s.args.chain.indexOf(this.folder.ref) != -1){
                    this.toggle()
                }
                // toggle selected status            
                if(s.event == 'ADD' && s.item.ref == this.folder.ref){
                    this.isSelected = true
                    this.cdr.detectChanges()
                }
                else if(s.event == 'REMOVE' && s.item.ref == this.folder.ref){
                    this.isSelected = false
                    this.cdr.detectChanges()
                }
            }))
        }
        this.cdr.detectChanges();
    }

    ngOnDestroy(){
        this.folder.unload()
        this.subs.forEach(s => s.unsubscribe())
    }
    private updateHasChildren(){
        this.hasChildren = this.folder.hasChildren
        
    }
    clicked(){
        // console.log('#clicked', this.id, this.folder);
        this.change.emit(new TreeEvent(this.folder,'selected'));
        this.cdr.detectChanges();
    }
    clickMe() {
        // console.log('#clickMe', this.id, this.isFile, this.folder );
        if ( this.isFile ) {
            // file clicked
            this.clicked();
        } else {
            // folder clicked
            this.toggle();  
        }
    }
    toggle(){
        // console.log('#toggle', this.id, this.folder);
        if(!this.folder.hasChildren) return

        if(!this.expanded){
            this.change.emit(new TreeEvent(this.folder,'expanded'))
            if(!this.children){
                this.children = []

                this.subs.push(this.folder.children.events.pipe(filter(ev => ev.event == 'UPDATE')).subscribe(_ => this.cdr.detectChanges()))
                this.subs.push(this.folder.children.state.subscribe(s => {
                    this.children = s
                    this.cdr.detectChanges()
                }))
                
                this.change.emit(new TreeEvent(this.folder,'fetching_children'))
                this.folder.loadChildren().subscribe(s => {
                
                    this.change.emit(new TreeEvent(this.folder,'fetched_children',{children:s}))

                })
            
            }
        }
        else{
            this.change.emit(new TreeEvent(this.folder,'collapsed'))
        }
        this.expanded = !this.expanded
    }

    onChecked(checked:boolean, item:TreeNode) {
        // console.log('#check', this.id, checked, item);
        this.change.emit(new TreeEvent(this.folder,'checked',checked));
        this.clicked();
    }

    uuid() {
        return 'xxx-xxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}